import React, { useEffect, useRef } from 'react';
import { Button } from 'antd';
import { useSessionApp, withNotificationActions } from '../../../utils/actionableNotifications';
export function useAiCreditWarnings(socket, enabled) {
  const { notification } = useSessionApp();
  const apiRef=useRef(notification); apiRef.current=notification;
  const last=useRef(null);
  useEffect(()=>{
    if (!socket || !enabled) return undefined;
    let alive=true;
    const api=withNotificationActions(apiRef.current);
    const changed=payload=>{
      if (!alive) return;
      const data=payload?.data || payload;
      if (!['warn','full'].includes(data?.warning)) return;
      const key=`${data.warning}:${data.used_percent}`;
      if (last.current?.key === key && Date.now()-last.current.at < 30000) return;
      last.current={key,at:Date.now()};
      api.warning({key:'ai-credit-warning',duration:10,message:data.warning === 'warn' ? `AI credit ${data.used_percent}% used. Add a recharge soon.` : 'AI credit estimate is used up. AI keeps working until OpenAI stops it.',actions:<Button href="/settings/integrations/ai-credits" size="small">AI Credits</Button>});
    };
    socket.on('ai.credit_warning',changed);
    return ()=>{alive=false;socket.off('ai.credit_warning',changed);api.destroy('ai-credit-warning');};
  },[socket,enabled]);
}
